import React from 'react';
import { graphql, useFragment } from 'react-relay/hooks';
import { Link } from 'react-router-dom';
import UserNameLabel from '~/components/UserNameLabel';
export const UserLink = (props) => {
    const { children, userRef } = props;
    const user = useFragment(graphql `
      fragment UserLink_user on User {
        ...UserNameLabel_user
        id
      }
    `, userRef);
    return <Link to={`/users/${user.id}`}>{children || <UserNameLabel user={user}/>}</Link>;
};
export default UserLink;
